import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";
import type { WardOccupancyRow } from "@/api/intelligence";
import { formatCount } from "@/lib/intelligenceFormat";

type Props = {
	wards: WardOccupancyRow[];
};

export function WardOccupancyTable({ wards }: Props) {
	return (
		<div className="rounded-lg border overflow-x-auto">
			<Table>
				<TableHeader>
					<TableRow>
						<TableHead>Ward</TableHead>
						<TableHead>Type</TableHead>
						<TableHead className="text-right">Beds</TableHead>
						<TableHead className="text-right">Occupied</TableHead>
						<TableHead className="text-right">Available</TableHead>
						<TableHead className="text-right">Occupancy</TableHead>
					</TableRow>
				</TableHeader>
				<TableBody>
					{wards.length === 0 ? (
						<TableRow>
							<TableCell colSpan={6} className="text-center text-muted-foreground py-8">
								No wards with beds configured
							</TableCell>
						</TableRow>
					) : (
						wards.map((w) => (
							<TableRow key={w.wardId}>
								<TableCell className="font-medium">{w.wardName}</TableCell>
								<TableCell className="text-sm text-muted-foreground">{w.type}</TableCell>
								<TableCell className="text-right tabular-nums">{formatCount(w.totalBeds)}</TableCell>
								<TableCell className="text-right tabular-nums">{formatCount(w.occupied)}</TableCell>
								<TableCell className="text-right tabular-nums">{formatCount(w.available)}</TableCell>
								<TableCell className="text-right tabular-nums font-medium">
									{w.occupancyPercent}%
								</TableCell>
							</TableRow>
						))
					)}
				</TableBody>
			</Table>
		</div>
	);
}
